import { render, staticRenderFns } from "./itc-register.vue?vue&type=template&id=9207044c&scoped=true"
import script from "./itc-register.vue?vue&type=script&lang=js"
export * from "./itc-register.vue?vue&type=script&lang=js"
import style0 from "./itc-register.vue?vue&type=style&index=0&id=9207044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9207044c",
  null
  
)

export default component.exports